import { useMemo } from "react";

import { PopupOnClick } from "components/popups";
import { FieldProps } from "src/types/form";
import { getCountries } from "utils/continents";

import styles from "./CountriesCompactField.scss";
import { CountriesField } from "./CountriesField";
import { CountryInput } from "./CountryInput";

export function CountriesCompactField({ ...props }: FieldProps) {
  const { name, required = true, ...rest } = props;

  const validCodes = useMemo(() => {
    return new Set(getCountries().map((c) => c.code));
  }, []);

  // @todo Make the pop-up distinctive from the background form.
  const renderPopup = () => <CountriesField name={name} />;

  const renderTrigger = () => (
    <CountryInput
      name={name}
      validCodes={validCodes}
      required={required}
      {...rest}
    />
  );

  return (
    <PopupOnClick
      alignment="bottom-start"
      className={styles.popup}
      renderPopup={renderPopup}
      renderTrigger={renderTrigger}
    />
  );
}
